import { useQuery } from '@tanstack/react-query';
import { mobietrainGraphql } from './graphql';

const ME_QUERY = `
  query MobietrainMe {
    users {
      me {
        id
        lastAccount {
          id
        }
      }
    }
  }
`;

interface MeResponse {
  users: {
    me: {
      id: string;
      lastAccount: {
        id: string;
      };
    };
  };
}

export interface MobietrainUser {
  userId: number;
  accountId: number;
}

export const useMobietrainUser = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['mobietrain-user'],
    queryFn: async (): Promise<MobietrainUser> => {
      const res = await mobietrainGraphql<MeResponse>(ME_QUERY);
      return {
        userId: Number(res.users.me.id),
        accountId: Number(res.users.me.lastAccount.id),
      };
    },
    staleTime: Infinity,
    retry: false,
    enabled,
  });
};
